
import React from "react";
import { BookOpen, Check } from "lucide-react";

interface BookPreviewProps {
  className?: string;
  showFullDetails?: boolean;
}

const BookPreview: React.FC<BookPreviewProps> = ({ className = "", showFullDetails = false }) => {
  return (
    <div className={`bg-white rounded-lg shadow-md overflow-hidden ${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="flex justify-center items-center p-4">
          <img 
            src="https://qcgnklqgyzwvjrmhzwfj.supabase.co/storage/v1/object/public/assets/book-cover.png" 
            alt="AI Oversight in the Boardroom book cover" 
            className="max-h-96 object-contain shadow-lg rounded-md hover:scale-105 transition-transform duration-300"
          />
        </div>
        
        <div className="p-6 flex flex-col justify-center">
          <div className="mb-4">
            <h3 className="text-xl md:text-2xl font-bold text-techne-primaryPurple mb-2">
              AI Oversight in the Boardroom
            </h3>
            <h4 className="text-md md:text-lg text-gray-700 mb-4">
              A Director's Handbook for Navigating the Next Frontier of Corporate Governance
            </h4>
            <p className="text-gray-600 italic mb-2">By Khullani Abdullahi, JD</p>
          </div>
          
          {showFullDetails && (
            <div className="space-y-4">
              <p className="text-gray-600">
                The definitive guide for board directors to effectively oversee and govern artificial intelligence initiatives in their organizations.
              </p>
              
              <div className="space-y-2">
                <h5 className="font-semibold text-techne-purple">Included with your Blueprint Course enrollment:</h5>
                <ul className="space-y-1">
                  {[
                    "Complete AI governance frameworks",
                    "Practical oversight templates",
                    "Risk assessment tools",
                    "Regulatory compliance guidance",
                    "Implementation roadmaps"
                  ].map((item, index) => (
                    <li key={index} className="flex items-start">
                      <Check className="h-5 w-5 text-techne-purple mr-2 flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          
          {!showFullDetails && (
            <div className="flex items-center text-techne-purple mt-2">
              <BookOpen className="h-5 w-5 mr-2" />
              <span className="font-medium">Included with your course enrollment</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookPreview;
